import PapillonDarkTheme from './papillonDark'
import PapillonLightTheme from './papillonLight'
import MiPasaDarkTheme from './mipasaDark'
import MiPasaLightTheme from './mipasaLight'
import UnboundedDarkTheme from './unboundedDark'
import UnboundedLightTheme from './unboundedLight'
import { Theme } from '../theme.types'

export enum ThemeName {
  papillonDark = 'PapillonDark',
  papillonLight = 'PapillonLight',
  mipasaDark = 'MiPasaDark',
  mipasaLight = 'MiPasaLight',
  unboundedDark = 'UnboundedDark',
  unboundedLight = 'UnboundedLight',
}

export const themes: Record<ThemeName, Theme> = {
  [ThemeName.papillonDark]: PapillonDarkTheme,
  [ThemeName.papillonLight]: PapillonLightTheme,
  [ThemeName.mipasaDark]: MiPasaDarkTheme,
  [ThemeName.mipasaLight]: MiPasaLightTheme,
  [ThemeName.unboundedDark]: UnboundedDarkTheme,
  [ThemeName.unboundedLight]: UnboundedLightTheme,
}
